import React from 'react';
import PropTypes from 'prop-types';
import { useScript } from '../hooks/useScript';

const scriptAttributes = {
  async: true,
  type: 'text/javascript',
  text: `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-W7FRLJ');
  `
};

const noscriptHtml = '<noscript><iframe src=​"https://www.googletagmanager.com/ns.html?id=GTM-W7FRLJ" height=​"0"​ width=​"0"​ style=​"display:none;visibility:hidden"​/></noscript>';

const REQUIRED_CONSENT_LEVEL = 2;

export const useGoogleTagManager = consentLevel => {
  const hasConsent = consentLevel >= REQUIRED_CONSENT_LEVEL;
  useScript('head', scriptAttributes, hasConsent);
};

export const GoogleTagManager = ({ consentLevel }) => {
  useGoogleTagManager(consentLevel);

  return (
    consentLevel >= REQUIRED_CONSENT_LEVEL && <div dangerouslySetInnerHTML={{ __html: noscriptHtml }} />
  );
};

GoogleTagManager.propTypes = {
  consentLevel: PropTypes.number
};
